<template>
  <div class="booking-popup-mobile-fieldset">
    <div :class="{'fieldset-popup': isMultiselectIsActive}" v-if="!isCustomOffer && isShowMinPrice">
      <div class="booking-popup-mobile-fieldset__popup-top" v-if="!isCustomOffer  && isMultiselectIsActive">
        <div class="booking-popup-mobile-fieldset__popup-top-btn">
          <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M9 12L5 8L9 4" stroke="#222222" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
        </div>
        <div class="booking-popup-mobile-fieldset__popup-top-full">
          {{ $t('bookingPopup.fieldset.chooseDates') }}
        </div>
      </div>
      <multiselect-offers
        ref="multiselectOffers"
        v-if="!isCustomOffer && isShowMinPrice"
        :selected-option="selectedOffer"
        :options="offers"
        :currency="currency"
        class="booking-popup-mobile-fieldset__item-multiselect"
        :disabled="pending"
        :placeholder="$t('bookingPopup.fieldset.chooseDates')"
        :is-offer-selected="isOfferSelected"
        :await-next-page="awaitNextPage"
        @close="setMultiselectIsActive(false)"
        @open="setMultiselectIsActive(true)"
        @click.native="trackEvents('Tour detail Booking', 'Click Dates')"
        @selectOption="$emit('update:selectedOffer', $event)"
      />
    </div>
    <multiselect
      v-if="!isCustomOffer && !isShowMinPrice"
      ref="multiselectOffers"
      class="booking-popup-mobile-fieldset__item"
      :value="selectedOffer"
      :options="offers"
      :max-height="270"
      :searchable="false"
      :allow-empty="false"
      select-label=""
      selected-label=""
      deselect-label=""
      track-by="id"
      label="formattedRange"
      :disabled="pending"
      @click.native="trackEvents('Tour detail Booking', 'Click Dates')"
      @input="$emit('update:selectedOffer', $event)"
    >
      <template #singleLabel="{ option: { formattedRange } }">
        <div
          class="
            booking-popup-mobile-fieldset__placeholder
            font-text-small
            u-text-secondary
          "
          v-html="$t('bookingPopup.fieldset.chooseDates')"
        >

        </div>
        <div
          class="booking-popup-mobile-fieldset__title font-semibold"
          v-html="formattedRange"
        ></div>
      </template>
      <template #caret>
        <button
          type="button"
          class="booking-popup-mobile-fieldset__caret u-decor u-flex-shrink-0"
        >
          <svg-inline tag="span" dir="down" class="u-stroke-deep-current">
            <icon icon="icon-angle-up" classMod="no-fill"/>
          </svg-inline>
        </button>
      </template>
      <template #option="{ option: { formattedRange } }">
        <div class="font-text" v-html="formattedRange"></div>
      </template>
      <template #afterList>
        <div class="multiselect-offers__loader" v-if="awaitNextPage">
          <loader visible/>
        </div>
      </template>
    </multiselect>

    <slide-toggle>
      <div
        v-if="isCustomOffer"
        class="booking-popup-mobile-fieldset__item"
        :class="{ 'booking-popup-mobile-fieldset__item--invalid': error }"
      >
        <date-picker
          v-model="range"
          :editable="false"
          prefix-class="serp"
          :placeholder="$t('bookingPopup.fieldset.customDatesPlaceholder')"
          :disabled-date="getDisabledCustomDates"
          value-type="format"
          format="DD.MM.YYYY"
          range-separator=" — "
          :lang="datepickerLang"
          :append-to-body="false"
          range
          @input="$emit('update:range', $event)"
        />
      </div>
    </slide-toggle>
    <div class="booking-popup-mobile-fieldset__item">
      <div class="booking-popup-mobile-fieldset__participants">
        <div
          class="booking-popup-mobile-fieldset__title font-semibold"
          v-html="$t('bookingPopup.fieldset.participants')"
        ></div>
        <div
          class="booking-popup-mobile-fieldset__participants-counter u-flex-shrink-0"
        >
          <counter
            :model-value="participants"
            :min="1"
            :max="counterMax"
            :disabled="pending"
            @change="$emit('update:participants', $event)"
            @decrement="updateParticipants"
            @increment="updateParticipants"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import multiselectOffers from "@/components/ui-kit/multiselect-offers/index.vue";
import Multiselect from "vue-multiselect";
import SvgInline from "@/components/ui-kit/svg-inline/index.vue";
import Icon from "@/components/icons/index.vue";

import SlideToggle from "@/components/ui-kit/slide-toggle/index.vue";
import DatePicker from "vue2-datepicker";
import Counter from "@/components/ui-kit/counter/index.vue";
import {ytEvents} from "@/plugins/analytics";
import {mapState} from "vuex";
import loader from "@/components/ui-kit/loader-icon/index.vue";

export default {
  components: {
    loader,
    Multiselect,
    SvgInline,
    Icon,
    SlideToggle,
    DatePicker,
    Counter,
    multiselectOffers,

  },
  data() {
    return {
      multiselectIsActive: false,
    }
  },
  props: {
    selectedOffer: {
      type: Object,
      required: false,
    },
    offers: {
      type: Array,
      required: false,
    },
    isCustomOffer: {
      type: Boolean,
      default: false,
    },
    participants: {
      type: Number,
      required: true,
    },
    offer: {
      type: Object,
      required: false,
    },
    range: {
      type: Array,
      required: false,
    },
    pending: {
      type: Boolean,
      default: false,
    },
    error: {
      type: Boolean,
      default: false,
    },
    isOfferSelected: {
      type: Boolean,
      default: false,
    },
    isShowMinPrice: {
      type: Boolean,
      default: false,
    },
    isAllOffersLoaded: {
      type: Boolean,
      default: false,
    },
    awaitNextPage: {
      type: Boolean,
      default: false,
    }
  },
  computed: {
    ...mapState({
      currency: (state) => state.currency.currency,
    }),
    isMultiselectIsActive(){
      return this.multiselectIsActive;
    },
    datepickerLang() {
      return this.$t("dateSelector.datepickerLang");
    },
    counterMax() {
      return !this.isCustomOffer ? this.offer.freeSpaces : undefined;
    },

  },
  methods: {
    getDisabledCustomDates(date) {
      const today = new Date();
      today.setHours(0, 0, 0, 0);

      return date < today;
    },
    setMultiselectIsActive(val) {
      this.multiselectIsActive = val
    },
    trackEvents(cat, name, lbl) {
      ytEvents.track(cat, name, lbl);
    },
    updateParticipants($event){
      this.trackEvents("Tour detail Participants", "Click Action button", $event);
    },
    scrollMultiselect(event){
      const target = event.target;
      const scrollHeight = target.scrollHeight;
      const scrollTop = target.scrollTop;
      const clientHeight = target.clientHeight;
      if (Math.round(scrollTop + clientHeight + 5) >= scrollHeight && !this.isAllOffersLoaded) {
        this.$emit('scroll-end');
      }

    }
  },
  mounted() {
    if (!this.isCustomOffer) {
      this.$watch(
        "offer",
        ({ freeSpaces }) => {
          if (this.participants > freeSpaces) {
            this.$emit("update:participants", freeSpaces);
          }

          if (this.participants === 0 && freeSpaces > 0) {
            this.$emit("update:participants", 1);
          }
        },
        {
          deep: true,
        }
      );
    }
    if( typeof this.$refs.multiselectOffers != "undefined") {
      const contentWrapper = this.$refs.multiselectOffers.$el.querySelector('.multiselect__content-wrapper');
      contentWrapper.addEventListener('scroll', this.scrollMultiselect);
    }
  },
};
</script>

<style lang="scss" scoped>
@import "~vue-multiselect/dist/vue-multiselect.min.css";

$m: ".multiselect";

.booking-popup-mobile-fieldset {
  &__popup-top {
    color: var(--black, #222);
    text-align: center;
    font-family: "SF Pro Text";
    font-size: 16px;
    font-style: normal;
    font-weight: 600;
    line-height: 19px; /* 118.75% */
    letter-spacing: -0.32px;
    height: 58px;
    background: #fff;
    top: 100px;
    position: absolute;
    width: 100%;
    left: 0;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0 16px;

    &-full {
      width: 100%;
    }

    &-btn  {
      width: 28px;
      height: 28px;
      border-radius: 100px;
      background: var(--grey-light, #EEEEF2);
      align-items: center;
      justify-content: center;
      display: flex;
    }
  }
  &__item {
    box-sizing: border-box;
    border: 1px solid var.$gray-dark;
    padding: 9px 16px;
    transition: var.$transition-default;

    &--invalid {
      border: 1px solid var.$ruby-300;
    }

    &:not(:first-child) {
      border-top: none;
    }

    &:first-child {
      border-top-left-radius: var.$rounded-8;
      border-top-right-radius: var.$rounded-8;

      &.multiselect--above.multiselect--active {
        border-radius: 0;
      }
    }

    &:last-child {
      border-bottom-right-radius: var.$rounded-8;
      border-bottom-left-radius: var.$rounded-8;
    }

    &#{$m}--active {
      border-color: var.$black;
    }
    &-multiselect {
      &:last-child {
        border-bottom-right-radius: 0!important;
        border-bottom-left-radius: 0!important;
      }
    }
  }


  &__placeholder {
    margin-bottom: 2px;
  }

  &__title {
    color: var.$black;
  }

  &__caret {
    @include mixin.button-reset();
    width: 20px;
    padding: 0;
    position: absolute;
    /*margin-left: 20px;*/
    color: var.$secondary;
    transition: var.$transition-default;

    #{$m}--active & {
      color: var.$black;
      transform: rotate(-180deg);
    }
  }

  &__participants {
    display: flex;
    align-items: center;
    justify-content: space-between;

    &-counter {
      margin: 7px 0 7px 20px;
    }
  }

  >>> {
    #{$m} {
      display: flex;
      flex-direction: row-reverse;
      align-items: center;

      &__tags {
        flex-grow: 1;
        min-width: 1px;
        padding: 0;
        min-height: 0;
        border: none;
        background: none;
      }

      &__single {
        display: block;
        min-height: 0;
        line-height: inherit;
        background: none;
        padding: 0;
        margin: 0;
      }

      &__content {
        padding: 8px;
      }

      &__content-wrapper {
        width: auto;
        top: calc(100% + 1px);
        right: -1px;
        left: -1px;
        box-shadow: 1px 4px 20px rgba(var.$secondary, 0.35);
        border: none;
        border-bottom-right-radius: var.$rounded-8;
        border-bottom-left-radius: var.$rounded-8;
      }

      &__element {
        padding: 0;
      }

      &__option {
        border-radius: 6px;
        padding: 12px;
        min-height: 0;
        color: var.$black;
        transition: var.$transition-default;

        &--selected {
          background: var.$green-main;

          &:not(#{$m}__option--highlight) {
            color: var.$white;
          }
        }

        &--highlight {
          background: var.$gray-pale;
        }
      }

      &--above {
        #{$m} {
          &__content-wrapper {
            top: auto;
            bottom: calc(100% + 1px);
            border-top-left-radius: var.$rounded-8;
            border-top-right-radius: var.$rounded-8;
          }
        }
      }

    }

    .serp-input-wrapper {
      .serp-input {
        padding: 9px 0;
        font-size: 14px;
      }
    }
  }
}
.fieldset-popup {
  position: fixed;
  height: calc(100vh + 100px);
  bottom: 0;
  background: #fff;
  left: 0;
  right: 0;
  z-index: 99999;
  top: -100px;
}
</style>
